import { CorrectionType } from './CorrectionType';

export class InvoiceSettlement {
  public static TYPE_RECEIPT = 'receipt';
  public static TYPE_CREDIT_INVOICE = 'credit-invoice';
  public static TYPE_INVOICE = 'invoice';
  public static TYPE_PREPAYMENT = 'prepayment';
  public static TYPE_ARCHIVED = 'archived';
  public static TYPE_CORRECTION_TRANSACTION = 'correction-transaction';

  public amount: number;
  public date: Date;
  public type: string;
  public invoiceNumber: string;
  public externalLabelKey: CorrectionType;
}
